import { render, staticRenderFns } from "./batch-uploader.vue?vue&type=template&id=15d2199e&scoped=true&"
import script from "./batch-uploader.vue?vue&type=script&lang=tsx&"
export * from "./batch-uploader.vue?vue&type=script&lang=tsx&"
import style0 from "./batch-uploader.vue?vue&type=style&index=0&id=15d2199e&prod&lang=scss&scoped=true&"
import style1 from "./batch-uploader.vue?vue&type=style&index=1&id=15d2199e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2199e",
  null
  
)

export default component.exports